<template>
  <div>
    <img @click="show_chat" class="YQ-icon" :src="url">
  </div>
</template>

<script>
export default {
  name: "icoShow",
  data() {
    return {
      url: ''
    }
  },
  mounted() {
    this.url = this.$route.query.iconUrl
    this.loading = true
  },
  methods:{
    //开启聊天窗口
    show_chat()
    {
      this.loading = false
      let data = {
        code : '201',
        msg : 'success'
      };
      window.parent.postMessage(data, '*');
    }

  },
}
</script>

<style scoped>
.YQ-icon{
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/common/icoShow.vue